import { MButton } from '../MButton/MButton';

import * as Styles from './ViewDetailsButton.styles';

export interface ViewDetailsButtonProps {
  onClick: () => void;
  testId?: string;
}

export const ViewDetailsButton = ({ onClick, testId }: ViewDetailsButtonProps) => (
  <MButton type='tertiary' className={Styles.viewDetailsButton} onClick={onClick} testId={testId}>
    View
  </MButton>
);
